/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_AccionAsync as AccionAsync,
  rec_Cargando as Cargando,
  rec_DetalleEstrategia as DetalleEstrategia,
  rec_EstadoError as EstadoError,
  rec_FormularioEstrategia as FormularioEstrategia,
  rec_Go as Go,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_Ti as Ti,
  rec_api as api,
} from "../../runtime/index.jsx";
export function EstrategiasUnidad(e) {
  let t = (0, ReactCompiler.c)(41),
    { unidadId: n, proyectos: r, onCambio: i } = e,
    a;
  t[0] === r
    ? (a = t[1])
    : ((a = r === void 0 ? [] : r), (t[0] = r), (t[1] = a));
  let o = a,
    s = Go(),
    [c, l] = (0, React.useState)(null),
    [u, f] = (0, React.useState)(``),
    [p, m] = (0, React.useState)(null),
    [h, _] = (0, React.useState)(null),
    v;
  t[2] === n
    ? (v = t[3])
    : ((v = async () => {
        f(``);
        try {
          l(
            await api(`/estrategias?unidad=${n}`, {
              sinCache: !0,
            }),
          );
        } catch (e) {
          f(e.message);
        }
      }),
      (t[2] = n),
      (t[3] = v));
  let y = v,
    b,
    x;
  (t[4] === y
    ? ((b = t[5]), (x = t[6]))
    : ((b = () => {
        y();
      }),
      (x = [y]),
      (t[4] = y),
      (t[5] = b),
      (t[6] = x)),
    (0, React.useEffect)(b, x));
  let S;
  t[7] === i
    ? (S = t[8])
    : ((S = function (e) {
        (l((t) => ({
          ...t,
          estrategias: t.estrategias.map((t) => (t.id === e.id ? e : t)),
        })),
          i?.());
      }),
      (t[7] = i),
      (t[8] = S));
  let C = S,
    w;
  t[9] !== s || t[10] !== y || t[11] !== C
    ? ((w = async function (e, t) {
        try {
          (C(
            await api(`/estrategias/${e.id}/proyectos`, {
              method: `POST`,
              body: {
                proyectoId: t,
              },
            }),
          ),
            s.ok(`Proyecto agregado a la estrategia`),
            y());
        } catch (e) {
          let t = e;
          s.error(t.message);
        }
      }),
      (t[9] = s),
      (t[10] = y),
      (t[11] = C),
      (t[12] = w))
    : (w = t[12]);
  let T = w,
    E;
  t[13] !== s || t[14] !== C
    ? ((E = async function (e, t) {
        try {
          (C(
            await api(`/estrategias/${e.id}/proyectos/${t.id}`, {
              method: `DELETE`,
            }),
          ),
            s.ok(`«${t.nombre}» ya no está en la estrategia`));
        } catch (e) {
          let t = e;
          s.error(t.message);
        }
      }),
      (t[13] = s),
      (t[14] = C),
      (t[15] = E))
    : (E = t[15]);
  let D = E,
    O;
  t[16] !== s || t[17] !== C
    ? ((O = function (e, t) {
        (_(null),
          t
            ? C(e)
            : (l((t) => ({
                ...t,
                estrategias: [...t.estrategias, e],
              })),
              m(e.id)),
          e.estado === `CUMPLIDA` && t?.estado !== `CUMPLIDA`
            ? s.logro(`Estrategia cumplida`, e.nombre)
            : s.ok(t ? `Cambios guardados` : `Estrategia creada`));
      }),
      (t[16] = s),
      (t[17] = C),
      (t[18] = O))
    : (O = t[18]);
  let k = O,
    A = !!c?.puedeEditar,
    j;
  t[19] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((j = (
        <p
          className={`text-sm font-medium text-(--text-h)`}
          children={`Estrategias`}
        />
      )),
      (t[19] = j))
    : (j = t[19]);
  let M;
  t[20] === A
    ? (M = t[21])
    : ((M = A && (
        <AccionAsync
          variante={`chico`}
          icono={Ti}
          onClick={() => _({})}
          children={`Nueva estrategia`}
        />
      )),
      (t[20] = A),
      (t[21] = M));
  let N;
  t[22] === M
    ? (N = t[23])
    : ((N = (
        <div
          className={`flex items-center justify-between gap-2`}
          children={[j, M]}
        />
      )),
      (t[22] = M),
      (t[23] = N));
  let P;
  t[24] !== p ||
  t[25] !== T ||
  t[26] !== y ||
  t[27] !== c ||
  t[28] !== A ||
  t[29] !== u ||
  t[30] !== o ||
  t[31] !== D
    ? ((P = u ? (
        <EstadoError mensaje={u} onReintentar={y} />
      ) : c ? (
        c.estrategias.length === 0 ? (
          <p
            className={`rounded-xl border border-dashed border-(--border) px-3 py-4 text-center text-sm text-(--text)`}
            children={
              A
                ? `Todavía no hay estrategias. Crea la primera para agrupar los proyectos de esta unidad.`
                : `Esta unidad todavía no tiene estrategias.`
            }
          />
        ) : (
          <ul
            className={`animar-cascada flex flex-col gap-2`}
            children={c.estrategias.map((e) => (
              <DetalleEstrategia
                key={e.id}
                e={e}
                abierta={p === e.id}
                onAlternar={() => m((t) => (t === e.id ? null : e.id))}
                editable={A}
                proyectosDeLaUnidad={o}
                estrategias={c.estrategias}
                onEditar={() =>
                  _({
                    editar: e,
                  })
                }
                onAgregar={(t) => T(e, t)}
                onSacar={(t) => D(e, t)}
              />
            ))}
          />
        )
      ) : (
        <Cargando variante={`filas`} cantidad={2} />
      )),
      (t[24] = p),
      (t[25] = T),
      (t[26] = y),
      (t[27] = c),
      (t[28] = A),
      (t[29] = u),
      (t[30] = o),
      (t[31] = D),
      (t[32] = P))
    : (P = t[32]);
  let F;
  t[33] !== k || t[34] !== h || t[35] !== n
    ? ((F = h && (
        <FormularioEstrategia
          unidadId={n}
          estrategia={h.editar}
          onClose={() => _(null)}
          onGuardado={(e) => k(e, h.editar)}
        />
      )),
      (t[33] = k),
      (t[34] = h),
      (t[35] = n),
      (t[36] = F))
    : (F = t[36]);
  let I;
  return (
    t[37] !== N || t[38] !== P || t[39] !== F
      ? ((I = (
          <section
            className={`flex flex-col gap-2`}
            aria-label={`Estrategias`}
            children={[N, P, F]}
          />
        )),
        (t[37] = N),
        (t[38] = P),
        (t[39] = F),
        (t[40] = I))
      : (I = t[40]),
    I
  );
}
